import { ErrorHandler, Injectable } from "@angular/core";
import { InsightsService } from "./Insights.service";

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService extends ErrorHandler{

    constructor(private insightService: InsightsService){
        super();
    }


    handleError(error: Error){
        this.insightService.logException(error);
    }

}
